export { default } from './dist/vue-typed-js.common'
export * from './dist/vue-typed-js.common'
import './dist/vue-typed-js.css'
